import { t } from 'ttag';

import OutIcon from '@svg/out.svg';
import { logout } from '@utils/common';
import { Link } from '@ui/Link';

import s from './UserMenuLinks.sss';

export interface UserMenuLink {
  icon: React.FC<React.SVGProps<SVGAElement>>,
  name: string,
  href: string,
  fill?: string,
  onClick: () => void,
}

interface Props {
  links: UserMenuLink[],
}

export const UserMenuLinks: React.FC<Props> = ({
  links,
}) => {
  const onLogoutClick = async (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    await logout();
    window.location.replace('/');
  };
 
  return (
    <ul className={s.list}>
      {links.map((link) => {
        const Icon = link.icon;

        return (
          <li
            key={link.href}
            className={s.item}
          >
            <Link
              className={s.link}
              theme='black'
              href={link.href}
              onClick={link.onClick}
            >
              <Icon
                className={s.icon}
                width='24'
                height='24'
                {...(link.fill && {
                  fill: '#B6A9F7',
                })}
              />
              {link.name}
            </Link>
          </li>
        );
      })}

      <li className={s.item}>
        <Link
          className={s.link}
          theme='black'
          onClick={onLogoutClick}
        >
          <OutIcon
            className={s.icon}
            width='24'
            height='24'
          />
          {t`Вийти`}
        </Link>
      </li>
    </ul>
  );
};
